import { useLoad } from '@gogame/query';

import { loadIo } from '../sources/io';
import { model } from './queryKeyFactory';

export const useLoadIo = (id) => {
  return useLoad(model(id), () => loadIo({ id }));
};
